import API from "../api";
import { apiCallbackTreatment } from "../auxiliary/generalFunctions";

const api = new API();

export default class CommissionRulesDetailsProspectionController
{
    async create(data) 
    {
        const response = await api.commissionRulesDetailsProspection().post(data);
        return apiCallbackTreatment(response);
    }

    async deleteById(id)
    {
        const response = await api.commissionRulesDetailsProspection().remove(id);
        return apiCallbackTreatment(response);
    }

    async update(id, data) {
        const response = await api.commissionRulesDetailsProspection().update(id, data);
        return apiCallbackTreatment(response);
    }
}